module.exports = __webpack_public_path__ + "static/regex-c43bb5ce949a255ee95db5fc320003da.jpg";